export default __webpack_public_path__ + "static/media/2_Recepcion_invitado.f1137ed9.mp3";